module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recentMatches
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "background-color": "#272839"
          }
        }, [_c('Match', {
          attrs: {
            "match-id": scope.row.match_id
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Hero"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('img', {
          attrs: {
            "src": scope.row.hero.icons.hero_full_icon,
            "alt": ""
          }
        }), _vm._v(" "), _c('p', {
          staticStyle: {
            "margin-left": "5px"
          }
        }, [_vm._v(_vm._s(scope.row.hero.localized_name)), _c('br'), _vm._v("\n        " + _vm._s(scope.row.player_team) + " " + _vm._s(scope.row.is_roaming ? ' / Roaming' : (scope.row.lane_name ? ' / ' + scope.row.lane_name : '')))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "MATCH",
      "prop": "match_id",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('p', [_vm._v(_vm._s(scope.row.match_id)), _c('br'), _vm._v("\n        " + _vm._s(scope.row.game_mode))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "RESULT"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('p', [_vm._v(_vm._s(scope.row.player_result ? 'Win' : 'Loss')), _c('br'), _vm._v("\n        " + _vm._s(scope.row.skill_level))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DURATION",
      "prop": "duration",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrapper"
        }, [_c('p', [_vm._v(_vm._s(scope.row.formatted_duration)), _c('br'), _vm._v("\n        " + _vm._s(scope.row.started_date))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "KILLS",
      "prop": "kills",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DEATHS",
      "prop": "deaths",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "ASSISTS",
      "prop": "assists",
      "width": "120",
      "sortable": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-165f471b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview.vue
// module id = 135
// module chunks = 1